import React, { useCallback, useMemo, useState } from "react";
import {
  buildSocialShareHref,
  getSharePageUrl,
  SOCIAL_SHARE_NETWORKS,
} from "../../utils/socialShare";

function SocialShare({ title, text }) {
  const [copied, setCopied] = useState(false);
  const shareUrl = getSharePageUrl();
  const shareText = useMemo(() => {
    const snippet = (text || "").trim();
    if (!snippet) return title;
    return snippet.length > 160 ? `${snippet.slice(0, 157)}…` : snippet;
  }, [text, title]);

  const canNativeShare =
    typeof navigator !== "undefined" && typeof navigator.share === "function";

  const handleNativeShare = useCallback(async () => {
    try {
      await navigator.share({
        title,
        text: shareText,
        url: shareUrl,
      });
    } catch (err) {
      if (err?.name !== "AbortError") {
        console.warn("[SocialShare]", err);
      }
    }
  }, [shareText, shareUrl, title]);

  const handleCopyLink = useCallback(async () => {
    try {
      await navigator.clipboard.writeText(shareUrl);
      setCopied(true);
      window.setTimeout(() => setCopied(false), 2500);
    } catch {
      window.prompt("Copia este enlace:", shareUrl);
    }
  }, [shareUrl]);

  const sharePayload = { url: shareUrl, title, text: shareText };
  const whatsapp = SOCIAL_SHARE_NETWORKS.find((n) => n.id === "whatsapp");

  const rootClassName = [
    "course-detail__share",
    canNativeShare ? "course-detail__share--has-native" : "",
  ]
    .filter(Boolean)
    .join(" ");

  const copyLabel = copied ? "Enlace copiado" : "Copiar enlace";

  return (
    <div className={rootClassName} aria-label="Compartir programa">
      <p className="course-detail__share__label">Compartir este programa</p>

      {canNativeShare ? (
        <button
          type="button"
          className="course-detail__share__btn course-detail__share__btn--native"
          onClick={handleNativeShare}
        >
          Compartir
        </button>
      ) : null}

      {canNativeShare && whatsapp ? (
        <div className="course-detail__share__quick">
          <a
            className="course-detail__share__btn course-detail__share__btn--whatsapp"
            href={buildSocialShareHref(whatsapp.id, sharePayload)}
            target="_blank"
            rel="noopener noreferrer"
          >
            WhatsApp
          </a>
          <button
            type="button"
            className="course-detail__share__btn course-detail__share__btn--copy"
            onClick={handleCopyLink}
            aria-live="polite"
          >
            {copyLabel}
          </button>
        </div>
      ) : null}

      <div className="course-detail__share__actions">
        {SOCIAL_SHARE_NETWORKS.map(({ id, label }) => (
          <a
            key={id}
            className={`course-detail__share__btn course-detail__share__btn--${id}`}
            href={buildSocialShareHref(id, sharePayload)}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={`Compartir en ${label}`}
          >
            {label}
          </a>
        ))}
        {!canNativeShare ? (
          <button
            type="button"
            className="course-detail__share__btn course-detail__share__btn--copy"
            onClick={handleCopyLink}
            aria-live="polite"
          >
            {copyLabel}
          </button>
        ) : null}
      </div>
    </div>
  );
}

export default SocialShare;
